<template>
<div>
  <div>
    <table align="center" cellspacing="0" class="Table"
           style="border-collapse:collapse; border:none; font-family:'Times New Roman'; font-size:13px">
      <tbody>
      <tr>
        <td colspan="5"
            style="border-bottom:1px solid black; border-left:none; border-right:none; border-top:none; vertical-align:bottom; width:700px">
          <p style="text-align:left">&nbsp;</p>

          <p style="text-align:left">&nbsp;</p>

          <p style="text-align:left"><strong><strong><span
            style="font-family:宋体; font-size:11pt">广东中奥物业管理有限公司</span><span
            style="font-size:14px">&nbsp;</span></strong></strong><strong
            style="font-family:'Times New Roman'; font-size:10.5pt"><span style="font-size:11.0000pt"><span
            style="font-family:宋体"><strong><span style="font-family:Arial,Helvetica,sans-serif">P41-01-0</span></strong></span></span></strong><strong
            style="font-family:'Times New Roman'; font-size:10.5pt"><span style="font-size:11.0000pt"><span
            style="font-family:宋体"><strong><span style="font-family:Arial,Helvetica,sans-serif">3</span></strong></span></span></strong>
          </p>
        </td>
      </tr>
      <tr>
        <td colspan="5"
            style="border-bottom:none; border-left:none; border-right:none; border-top:none; vertical-align:center; width:700px">
          <p style="text-align:center"><span style="font-size:10.5pt"><span
            style="font-family:'Times New Roman'"><strong><span style="font-size:20.0000pt"><span
            style="font-family:黑体"><strong><span
            style="font-family:黑体">装修备案表</span> </strong></span></span></strong></span></span></p>
        </td>
      </tr>
      <tr>
        <td colspan="5"
            style="border-bottom:none; border-left:none; border-right:none; border-top:none; vertical-align:center; width:700px">
          <p style="text-align:right"><span style="font-size:10.5pt"><span
            style="font-family:'Times New Roman'"><strong><span style="font-size:10.5000pt"><span
            style="font-family:宋体"><strong><span
            style="font-family:宋体">NO：</span></strong></span></span></strong><strong><span
            style="font-size:10.5000pt"><span style="font-family:宋体"><strong><span
            style="font-family:宋体">{{ form.FitmentID }}</span></strong></span></span></strong></span></span>
          </p>
        </td>
      </tr>
      <tr>
        <td
          style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid black; border-top:1px solid black; vertical-align:center; width:91px">
          <p style="text-align:center"><span style="font-size:10.5pt"><span
            style="font-family:'Times New Roman'"><strong><span style="font-size:12.0000pt"><span
            style="font-family:'Courier New'"><span
            style="font-family:宋体">装修单</span></span></span></strong><strong><span style="font-size:12.0000pt"><span
            style="font-family:宋体"><span style="font-family:宋体">元</span></span></span></strong></span></span></p>
        </td>
        <td colspan="2"
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:1px solid black; vertical-align:center; width:328px">
          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><strong><span
            style="font-size:12.0000pt"><span style="font-family:宋体"><span
            style="font-family:Courier New,Courier,monospace">{{form.house_name}}</span></span></span></strong></span></span>
          </p>
        </td>
        <td
          style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:1px solid black; vertical-align:center; width:98px">
          <p style="text-align:center"><span style="font-size:10.5pt"><span
            style="font-family:'Times New Roman'"><strong><span style="font-size:12.0000pt"><span
            style="font-family:'Courier New'"><span
            style="font-family:宋体">业主姓名</span></span></span></strong></span></span></p>
        </td>
        <td
          style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:1px solid black; vertical-align:center; width:183px">
          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><strong><span
            style="font-size:12.0000pt"><span style="font-family:宋体"><span
            style="font-family:Courier New,Courier,monospace">{{ form.customer_name }}</span></span></span></strong></span></span>
          </p>
        </td>
      </tr>
      <tr>
        <td
          style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid black; border-top:none; vertical-align:center; width:91px">
          <p style="text-align:center"><span style="font-size:10.5pt"><span
            style="font-family:'Times New Roman'"><strong><span style="font-size:12.0000pt"><span
            style="font-family:'Courier New'"><span
            style="font-family:宋体">装</span></span></span></strong><strong>&nbsp;</strong><strong><span
            style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span
            style="font-family:宋体">修</span></span></span></strong><strong>&nbsp;</strong><strong><span
            style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span
            style="font-family:宋体">商</span></span></span></strong></span></span></p>
        </td>
        <td colspan="2"
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:none; vertical-align:center; width:328px">
          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><strong><span
            style="font-size:12.0000pt"><span style="font-family:宋体"><span
            style="font-family:Courier New,Courier,monospace">{{ form.CompanyID }}</span></span></span></strong></span></span>
          </p>
        </td>
        <td
          style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:none; vertical-align:center; width:98px">
          <p style="text-align:center"><span style="font-size:10.5pt"><span
            style="font-family:'Times New Roman'"><strong><span style="font-size:12.0000pt"><span
            style="font-family:'Courier New'"><span
            style="font-family:宋体">资质等级</span></span></span></strong></span></span></p>
        </td>
        <td
          style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:none; vertical-align:center; width:183px">
          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
            style="font-size:12.0000pt"><span style="font-family:宋体"><span
            style="font-family:Courier New,Courier,monospace">{{ form.CompanyLevel }}</span></span></span></span></span></p>
        </td>
      </tr>
      <tr>
        <td
          style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid black; border-top:none; vertical-align:center; width:91px">
          <p style="text-align:center"><span style="font-size:10.5pt"><span
            style="font-family:'Times New Roman'"><strong><span style="font-size:12.0000pt"><span
            style="font-family:'Courier New'"><span
            style="font-family:宋体">负</span></span></span></strong><strong>&nbsp;</strong><strong><span
            style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span
            style="font-family:宋体">责</span></span></span></strong><strong>&nbsp;</strong><strong><span
            style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span
            style="font-family:宋体">人</span></span></span></strong></span></span></p>
        </td>
        <td
          style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:none; vertical-align:center; width:223px">
          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><strong><span
            style="font-size:12.0000pt"><span style="font-family:宋体"><span
            style="font-family:Courier New,Courier,monospace">{{ form.CompanyMaster }}</span></span></span></strong></span></span>
          </p>
        </td>
        <td
          style="border-bottom:1px solid black; border-left:none; border-right:1px solid #000000; border-top:none; vertical-align:center; width:105px">
          <p style="text-align:center"><span style="font-size:10.5pt"><span
            style="font-family:'Times New Roman'"><strong><span style="font-size:12.0000pt"><span
            style="font-family:'Courier New'"><span
            style="font-family:宋体">联系电话　</span></span></span></strong></span></span></p>
        </td>
        <td colspan="2"
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid #000000; border-top:none; vertical-align:center; width:281px">
          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><strong><span
            style="font-size:12.0000pt"><span style="font-family:宋体"><span
            style="font-family:Courier New,Courier,monospace">{{form.CompanyMasterPhone}}</span></span></span></strong></span></span>
          </p>
        </td>
      </tr>
      <tr>
        <td
          style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid black; border-top:none; vertical-align:center; width:91px">
          <p style="text-align:center"><span style="font-size:10.5pt"><span
            style="font-family:'Times New Roman'"><strong><span style="font-size:12.0000pt"><span
            style="font-family:'Courier New'"><span
            style="font-family:宋体">装修时间</span></span></span></strong></span></span></p>
        </td>
        <td colspan="4"
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:none; vertical-align:center; width:609px">
          <p style="text-align:center"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
            style="font-size:10.5000pt"><span style="font-family:'Courier New'"><span
            style="font-family:宋体">从</span></span></span><span style="font-size:10.5000pt"><span style="font-family:宋体"><span
            style="font-family:Courier New,Courier,monospace">{{form.BeginDate}} </span></span></span><span
            style="font-size:10.5000pt"><span style="font-family:'Courier New'"><span
            style="font-family:宋体">起至</span></span></span><span style="font-size:10.5000pt"><span
            style="font-family:宋体"><span
            style="font-family:Courier New,Courier,monospace">{{form.EndDate}}</span></span></span><span
            style="font-size:10.5000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">止　（共</span></span></span><span
            style="font-size:10.5000pt"><span style="font-family:宋体"><span
            style="font-family:Courier New,Courier,monospace">{{getDay(form.BeginDate,form.EndDate)}}</span></span></span><span
            style="font-size:10.5000pt"><span style="font-family:'Courier New'"><span
            style="font-family:宋体">天）</span></span></span></span></span></p>
        </td>
      </tr>
      <tr>
        <td rowspan="4"
            style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid black; border-top:none; vertical-align:center; width:91px">
          <p style="text-align:center"><span style="font-size:10.5pt"><span
            style="font-family:'Times New Roman'"><strong><span style="font-size:12.0000pt"><span
            style="font-family:'Courier New'"><span style="font-family:宋体">装</span><span style="font-family:宋体">修</span><span
            style="font-family:宋体">许</span><span style="font-family:宋体">可</span><span
            style="font-family:宋体">项</span><span style="font-family:宋体">目</span></span></span></strong></span></span>
          </p>
        </td>
        <td colspan="4" rowspan="2"
            style="border-bottom:1px solid #000000; border-left:none; border-right:1px solid #000000; border-top:none; vertical-align:center; width:609px">
          <p style="text-align:left">
            {{}}
          </p>
        </td>
      </tr>
      <tr>
      </tr>
      <tr>
        <td colspan="4"
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:none; vertical-align:center; width:609px">
          <p style="text-align:left">&nbsp;</p>
        </td>
      </tr>
      <tr>
        <td colspan="4"
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:none; vertical-align:center; width:609px">
          <p style="text-align:center">&nbsp;</p>
        </td>
      </tr>
      <tr>
        <td
          style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid black; border-top:none; vertical-align:center; width:91px">
          <p style="text-align:center"><span style="font-size:10.5pt"><span
            style="font-family:'Times New Roman'"><strong><span style="font-size:12.0000pt"><span
            style="font-family:'Courier New'"><span style="font-family:宋体">注</span><span style="font-family:宋体">意</span><span
            style="font-family:宋体">事</span><span style="font-family:宋体">项</span></span></span></strong></span></span>
          </p>
        </td>
        <td colspan="4"
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid #000000; border-top:none; vertical-align:center; width:609px">
          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
            style="font-size:9.0000pt"><span style="font-family:'Courier New'">1<span
            style="font-family:宋体">、拆墙（非外墙、</span></span></span><span style="font-size:9.0000pt"><span
            style="font-family:宋体"><span style="font-family:宋体">非</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">承重墙等，无影响外立面等）</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span
            style="font-family:宋体">须现场确认</span></span></span><span style="font-size:9.0000pt"><span
            style="font-family:'Courier New'"><span style="font-family:宋体">；</span> </span></span></span></span></p>

          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
            style="font-size:9.0000pt"><span style="font-family:'Courier New'">2<span style="font-family:宋体">、隐蔽工程封闭前须现场确认，</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span style="font-family:宋体">装饰</span><span
            style="font-family:Courier New,Courier,monospace">/</span><span style="font-family:宋体">封闭下水管道须预留检修口，</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">给水管布管安装须压力测试；</span></span></span></span></span>
          </p>

          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
            style="font-size:9.0000pt"><span style="font-family:'Courier New'">3<span style="font-family:宋体">、住宅类地板铺设不允许使用大理石（超荷载）等材质</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span style="font-family:宋体">；</span></span></span></span></span>
          </p>

          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
            style="font-size:9.0000pt"><span style="font-family:'Courier New'">4<span style="font-family:宋体">、商业（铺）物业门面（广告牌）安装须提供彩色立面效果图及施工图备案审核，同时须报当地政府主管部门审批；</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span style="font-family:宋体">天花吊顶每</span><span
            style="font-family:Courier New,Courier,monospace">60</span><span style="font-family:宋体">&mdash;</span><span
            style="font-family:Courier New,Courier,monospace">80</span><span style="font-family:宋体">平米须预留</span><span
            style="font-family:Courier New,Courier,monospace">600</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span
            style="font-family:宋体">&times;600mm规格的检口；</span></span></span></span></span></p>

          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
            style="font-size:9.0000pt"><span style="font-family:'Courier New'">5<span style="font-family:宋体">、空调安装须提前向物业服务中心咨询安装注意事宜，同时须按指定位置安装外机</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span
            style="font-family:宋体">，不得拆除或改变空调位格栅，以保证外立面统一</span></span></span><span style="font-size:9.0000pt"><span
            style="font-family:'Courier New'"><span style="font-family:宋体">；</span></span></span></span></span></p>

          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
            style="font-size:9.0000pt"><span style="font-family:'Courier New'">6<span style="font-family:宋体">、未尽事宜，请您详细咨询物业服务中心。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></span></span></span>
          </p>
        </td>
      </tr>
      <tr>
        <td rowspan="4"
            style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid black; border-top:none; vertical-align:center; width:91px">
          <p style="text-align:center"><span style="font-size:10.5pt"><span
            style="font-family:'Times New Roman'"><strong><span style="font-size:12.0000pt"><span
            style="font-family:'Courier New'"><span style="font-family:宋体">装</span><span style="font-family:宋体">修</span><span
            style="font-family:宋体">保</span><span style="font-family:宋体">证</span></span></span></strong></span></span>
          </p>
        </td>
        <td colspan="4" rowspan="4"
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:none; vertical-align:center; width:609px">
          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
            style="font-size:9.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">1、《装修</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span
            style="font-family:宋体">备案表</span></span></span><span style="font-size:9.0000pt"><span
            style="font-family:'Courier New'"><span
            style="font-family:宋体">》为一式二份：客户服务部存档一份、装修现场张贴一份</span></span></span><span style="font-size:9.0000pt"><span
            style="font-family:宋体"><span style="font-family:宋体">；</span></span></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          </p>

          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
            style="font-size:9.0000pt"><span style="font-family:'Courier New'">2</span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span
            style="font-family:宋体">、</span></span></span><span style="font-size:9.0000pt"><span
            style="font-family:'Courier New'"><span style="font-family:宋体">装修</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span style="font-family:宋体">施工</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">期间，请主动配合物业管理公司的装修</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span style="font-family:宋体">巡查</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:'Courier New'"><span
            style="font-family:宋体">工作</span></span></span><span style="font-size:9.0000pt"><span style="font-family:宋体"><span
            style="font-family:宋体">；</span></span></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          </p>

          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
            style="font-size:9.0000pt"><span style="font-family:'Courier New'">3</span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span
            style="font-family:宋体">、</span></span></span><span style="font-size:9.0000pt"><span
            style="font-family:'Courier New'"><span style="font-family:宋体">请严格按照装修</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span
            style="font-family:宋体">申报备案</span></span></span><span style="font-size:9.0000pt"><span
            style="font-family:'Courier New'"><span style="font-family:宋体">范围进行装修</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span style="font-family:宋体">施工</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">；如需进行新的装修项目，请业主提前亲临物业服务中心办理</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span style="font-family:宋体">备案</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">手续；一旦发现装修项目不在</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span
            style="font-family:宋体">申报备案</span></span></span><span style="font-size:9.0000pt"><span
            style="font-family:'Courier New'"><span style="font-family:宋体">范围内，物业</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span
            style="font-family:宋体">管理单位</span></span></span><span style="font-size:9.0000pt"><span
            style="font-family:'Courier New'"><span style="font-family:宋体">有权责令停工并限期整改</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span style="font-family:宋体">；</span></span></span></span></span>
          </p>

          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
            style="font-size:9.0000pt"><span style="font-family:'Courier New'">4</span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span
            style="font-family:宋体">、</span></span></span><span style="font-size:9.0000pt"><span
            style="font-family:'Courier New'"><span style="font-family:宋体">在装修期间的装修</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span
            style="font-family:宋体">及施工</span></span></span><span style="font-size:9.0000pt"><span
            style="font-family:'Courier New'"><span style="font-family:宋体">行为请严格遵守装修</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span
            style="font-family:宋体">之</span></span></span><span style="font-size:9.0000pt"><span
            style="font-family:'Courier New'"><span style="font-family:宋体">有关管理规定，不得改变阳台的样式或封闭阳台，禁止在阳台护栏、窗户等处设置任何形式的外置防盗网。不得改变外立面可见的门，</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span
            style="font-family:宋体">防盗门须按照统一款式、材质要求安装；</span></span></span><span style="font-size:9.0000pt"><span
            style="font-family:'Courier New'"><span style="font-family:宋体">不得占用楼道、露天平台等公共部分空间</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span style="font-family:宋体">私自搭建阳光房、安装太阳能等设施，以免破坏保温层，不得擅自改变房屋原设计使用功能；不得私自改动</span><span
            style="font-family:Courier New,Courier,monospace">/</span><span style="font-family:宋体">封闭</span><span
            style="font-family:Courier New,Courier,monospace">/</span><span
            style="font-family:宋体">影响各类公共设施、管线的正常使用；</span></span></span></span></span></p>

          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span
            style="font-family:Courier New,Courier,monospace">5</span><span style="font-family:宋体">、有防水处理要求的区域须进行二次防水处理并进行闭水试验；燃气管道改造、安装须由具备专业资质的施工单位进行，以免产生安全隐患；</span></span></span></span></span>
          </p>

          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span
            style="font-family:Courier New,Courier,monospace">6</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">、装修完毕后请通知物业管理公司进行装修竣工查验</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span style="font-family:宋体">；</span></span></span></span></span>
          </p>

          <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span
            style="font-family:Courier New,Courier,monospace">7</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">、查验不合格的装修项目，物业</span></span></span><span
            style="font-size:9.0000pt"><span style="font-family:宋体"><span
            style="font-family:宋体">管理单位</span></span></span><span style="font-size:9.0000pt"><span
            style="font-family:'Courier New'"><span style="font-family:宋体">有权责令限期整改，直至查验合格。</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></span></span>
          </p>
        </td>
      </tr>
      <tr>
      </tr>
      <tr>
      </tr>
      <tr>
      </tr>
      <tr>
        <td rowspan="2"
            style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid black; border-top:none; vertical-align:center; width:91px">
          <p style="text-align:center"><span style="font-size:10.5pt"><span
            style="font-family:'Times New Roman'"><strong><span style="font-size:12.0000pt"><span
            style="font-family:'Courier New'"><span
            style="font-family:宋体">责任</span></span></span></strong></span></span><span style="font-size:10.5pt"><span
            style="font-family:'Times New Roman'"><strong><span style="font-size:12.0000pt"><span
            style="font-family:'Courier New'"><span
            style="font-family:宋体">确认</span></span></span></strong></span></span></p>
        </td>
        <td colspan="4"
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:none; vertical-align:center; width:609px">
          <p style="text-align:justify"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
            style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span
            style="font-family:宋体">业主确认：</span></span></span><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong><span
            style="font-size:12.0000pt"><span style="font-family:'Courier New'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            style="font-family:宋体">日期：</span></span></span><span style="font-size:11.0000pt"><span
            style="font-family:宋体">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family:宋体">年</span> &nbsp;&nbsp;&nbsp;<span
            style="font-family:宋体">月</span></span></span><strong>&nbsp;&nbsp;&nbsp;&nbsp;</strong><span
            style="font-size:11.0000pt"><span style="font-family:宋体"><span style="font-family:宋体">日</span></span></span></span></span>
          </p>
        </td>
      </tr>
      <tr>
        <td colspan="4"
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:none; vertical-align:center; width:609px">
          <p style="text-align:justify"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
            style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span
            style="font-family:宋体">装修商负责人确认：</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>&nbsp;&nbsp;<span
            style="font-size:12.0000pt"><span style="font-family:'Courier New'">&nbsp;&nbsp;&nbsp;<span
            style="font-family:宋体">日期：</span></span></span><span style="font-size:11.0000pt"><span
            style="font-family:宋体">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family:宋体">年</span> &nbsp;&nbsp;&nbsp;<span
            style="font-family:宋体">月</span> &nbsp;&nbsp;&nbsp;<span style="font-family:宋体">日</span></span></span></span></span>
          </p>
        </td>
      </tr>
      <tr>
        <td
          style="border-bottom:1px solid #000000; border-left:1px solid black; border-right:1px solid black; border-top:none; vertical-align:center; width:91px">
          <p style="text-align:center"><span style="font-size:10.5pt"><span
            style="font-family:'Times New Roman'"><strong><span style="font-size:12.0000pt"><span
            style="font-family:宋体"><span style="font-family:宋体">备</span></span></span></strong></span></span><span
            style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><strong><span
            style="font-size:12.0000pt"><span style="font-family:宋体"><span style="font-family:宋体">案</span></span></span></strong><strong><span
            style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span
            style="font-family:宋体">单</span><span style="font-family:宋体">位</span></span></span></strong></span></span>
          </p>
        </td>
        <td colspan="4"
            style="border-bottom:1px solid #000000; border-left:none; border-right:1px solid #000000; border-top:none; vertical-align:center; width:609px">
          <p style="text-align:center">&nbsp;</p>

          <p style="text-align:right"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
            style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">广东中奥物业管理有限公司</span></span></span><strong><u><span
            style="font-size:12.0000pt"><span style="font-family:宋体"><u><span
            style="font-family:宋体">佛山南海</span></u></span></span></u></strong><span style="font-size:12.0000pt"><span
            style="font-family:'Courier New'"><span style="font-family:宋体">分公司</span></span></span></span></span></p>

          <p style="text-align:center"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<u><span
            style="font-size:12.0000pt"><span style="font-family:宋体"><u><span
            style="font-family:宋体">云山峰境</span></u></span></span></u><span style="font-size:12.0000pt"><span
            style="font-family:'Courier New'"><span style="font-family:宋体">管理处</span></span></span></span></span></p>

          <p style="text-align:justify"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span
            style="font-family:宋体">日</span></span></span>&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-size:12.0000pt"><span
            style="font-family:'Courier New'"><span style="font-family:宋体">期：</span> &nbsp;</span></span><span
            style="font-size:11.0000pt"><span style="font-family:宋体">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            style="font-family:宋体">年</span> &nbsp;&nbsp;&nbsp;&nbsp;<span
            style="font-family:宋体">月</span></span></span><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong><span
            style="font-size:11.0000pt"><span style="font-family:宋体"><span style="font-family:宋体">日</span></span></span></span></span>
          </p>
        </td>
      </tr>
      </tbody>
    </table>

  </div>
</div>
</template>

<script>
import moment from "moment";

export default {
  name: "FurnishFilings",
  inject:['mainObj','componentId','setComponentId','ProcessState','setProcessState'],
  data(){
    return{
      form:{},
    }
  },
  mounted() {
    const that = this;
    that.getData()
  },
  methods:{
    getData(){
      const that = this;
      ERP.postRequest({url:"admin/HouseFurnish/getFurnish",data:{house_id:that.mainObj.house_id,id:that.mainObj.id}},ret=>{
        if(ret.code){
          that.setProcessState(ret.data.ProcessState);
          that.form=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    getDay(start_time,end_time){
      if(start_time&&end_time){
        return moment(end_time).diff(moment(start_time), 'days');
      }else {
        return 0;
      }

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/FurnishFilings.vue